/*
 * @Author: Zhouqi
 * @Date: 2025-10-29 17:19:50
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-02 18:10:24
 */
import {
  isPreCn,
  isPreUs,
  isProdCn,
  isProduction,
  isProdUs,
  isQACn,
  isQAUs,
} from '@/utils/envHelper';
import { homeURL } from '@/utils/router';

const domainMap = {
  isProdUs: 'falcocut.ai',
  isPreOversea: 'falcocut.ai',
  isQACn: 'fireflyfusion.cn',
  isQAOversea: 'fireflyfusion.cn',
  default: 'localhost',
};

// 获取当前环境的域名
const getCurrentDomain = () => {
  if (isProdUs) return domainMap.isProdUs;
  if (isPreUs) return domainMap.isPreOversea;
  if (isQAUs) return domainMap.isQAOversea;
  return domainMap.default;
};

const base = {
  // 是否开启 redux devtools
  debuggable: isProduction ? false : true,
  APP_LANDING: homeURL,
  COOKIE_DOMAIN: getCurrentDomain(),
};

export default base;
